// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__1Hsgw","backButtonWithAction":"BackButton_backButtonWithAction__23sQy","backButtonTitle":"BackButton_backButtonTitle__21tj7"};